// extracted by mini-css-extract-plugin
export default {"textScrollerContainer":"TextScroller_textScrollerContainer__Ikc0+","textWrapper":"TextScroller_textWrapper__3ThDe","textItem":"TextScroller_textItem__Lep8N"};